const fr = {
  "nav.home": "Accueil",
  "nav.services": "Services Clients",
  "nav.services.website": "Création de Site Web",
  "nav.services.smm": "SMM / Marketing sur les Réseaux Sociaux",
  "nav.services.traffic": "Forfaits Traffic / Marketing Digital",
  "nav.aiTools": "Hub Outils IA",
  "nav.aiTools.reviews": "Avis sur les Outils IA",
  "nav.aiTools.guides": "Guides & Tutoriels",
  "nav.aiTools.landing": "Pages d'Atterrissage / Offres",
  "nav.about": "À Propos",
  "nav.profile": "Profil",
  "nav.contact": "Contact",
  "nav.getStarted": "Commencer",
  "nav.language": "Langue",

  "hero.eyebrow": "L'Agence Digitale Numéro 1 en Ouganda",
  "hero.title1": "Transformez Votre",
  "hero.title2": "Présence Digitale",
  "hero.title3": "Avec BientoMart",
  "hero.subtitle": "Nous créons des sites web époustouflants, développons vos réseaux sociaux et vous connectons aux meilleurs outils IA pour propulser votre business en Afrique de l'Est.",
  "hero.cta1": "Découvrir les Services",
  "hero.cta2": "Voir les Outils IA",
  "hero.stat1.value": "30+",
  "hero.stat1.label": "Projets Livrés",
  "hero.stat2.value": "98%",
  "hero.stat2.label": "Satisfaction Client",
  "hero.stat3.value": "24/7",
  "hero.stat3.label": "Support Disponible",

  "services.label": "Nos Services",
  "services.title": "Tout Ce Qu'il Faut Pour Réussir en Ligne",
  "services.subtitle": "Des sites web époustouflants aux stratégies de réseaux sociaux puissantes, nous livrons des résultats mesurables pour les entreprises ougandaises.",
  "services.learnMore": "En Savoir Plus",
  "services.websiteTitle": "Création de Site Web",
  "services.websiteDesc": "Sites web sur mesure, optimisés pour le SEO, qui convertissent les visiteurs en clients payants.",
  "services.websiteFeature1": "Design responsive personnalisé",
  "services.websiteFeature2": "SEO optimisé dès le départ",
  "services.websiteFeature3": "Rapide et sécurisé",
  "services.websiteFeature4": "Système de gestion de contenu",
  "services.websiteFrom": "À partir de 299$",
  "services.smmTitle": "Marketing sur les Réseaux Sociaux",
  "services.smmDesc": "Gestion stratégique des réseaux sociaux qui construit votre marque et développe votre audience.",
  "services.smmFeature1": "Création et planification de contenu",
  "services.smmFeature2": "Stratégie d'engagement d'audience",
  "services.smmFeature3": "Analyses et rapports mensuels",
  "services.smmFeature4": "Gestion des publicités payantes",
  "services.smmFrom": "À partir de 150$/mois",
  "services.trafficTitle": "Traffic & Marketing Digital",
  "services.trafficDesc": "Campagnes ciblées qui génèrent du trafic qualifié et boostent vos revenus en ligne.",
  "services.trafficFeature1": "Campagnes Google Ads",
  "services.trafficFeature2": "Publicités Facebook & Instagram",
  "services.trafficFeature3": "SEO & optimisation des mots-clés",
  "services.trafficFeature4": "Optimisation du taux de conversion",
  "services.trafficFrom": "À partir de 200$/mois",

  "aiTools.label": "Hub Outils IA",
  "aiTools.title": "Découvrez des Outils IA Puissants",
  "aiTools.subtitle": "Recommandations sélectionnées et avis honnêtes pour booster votre productivité.",
  "aiTools.readReview": "Lire l'Avis Complet",
  "aiTools.rating": "Note",
  "aiTools.tryNow": "Essayer Maintenant",
  "aiTools.textGenTitle": "Meilleur Générateur de Texte IA",
  "aiTools.textGenCategory": "Création de Contenu",
  "aiTools.textGenDesc": "Générez des articles, copies et contenus marketing de qualité en quelques secondes avec Jasper AI.",
  "aiTools.imageGenTitle": "Générateur d'Images IA",
  "aiTools.imageGenCategory": "Design Visuel",
  "aiTools.imageGenDesc": "Créez des visuels époustouflants, images produits et graphiques marketing avec Midjourney.",
  "aiTools.videoCreatorTitle": "Créateur de Vidéos IA",
  "aiTools.videoCreatorCategory": "Production Vidéo",
  "aiTools.videoCreatorDesc": "Transformez vos scripts en vidéos professionnelles en quelques minutes avec Pictory AI.",

  "about.label": "À Propos de BientoMart",
  "about.title": "Votre Partenaire Digital de Confiance en Ouganda",
  "about.p1": "BientoMart est la première plateforme de services digitaux en Ouganda, aidant les entreprises et entrepreneurs à construire de puissantes présences en ligne depuis 2020.",
  "about.p2": "Notre équipe de designers experts, marketeurs et spécialistes IA travaille sans relâche pour livrer des résultats exceptionnels à nos clients à travers l'Afrique de l'Est.",
  "about.p3": "Nous combinons la technologie de pointe avec une connaissance approfondie du marché local pour créer des stratégies digitales qui résonnent vraiment avec les audiences ougandaises.",
  "about.stat1.value": "5+",
  "about.stat1.label": "Années d'Activité",
  "about.stat2.value": "50+",
  "about.stat2.label": "Clients Satisfaits",
  "about.stat3.value": "30+",
  "about.stat3.label": "Projets Réalisés",
  "about.cta": "Engagez-Nous Aujourd'hui",

  "testimonials.label": "Témoignages de Réussite",
  "testimonials.title": "Ce Que Disent Nos Clients",
  "testimonials.subtitle": "Des résultats réels d'entreprises ougandaises réelles",

  "contact.label": "Prenez Contact",
  "contact.title": "Commencez Votre Parcours Digital Aujourd'hui",
  "contact.subtitle": "Prêt à porter votre business au niveau supérieur ? Parlons de la façon dont BientoMart peut vous aider à réussir en ligne.",
  "contact.name": "Nom Complet",
  "contact.email": "Adresse Email",
  "contact.phone": "Numéro de Téléphone",
  "contact.service": "Service Souhaité",
  "contact.message": "Votre Message",
  "contact.send": "Envoyer le Message",
  "contact.sending": "Envoi en cours...",
  "contact.success": "Merci ! Votre message a été envoyé. Nous vous répondrons dans les 24 heures.",
  "contact.error": "Une erreur s'est produite. Veuillez réessayer.",
  "contact.address": "Kampala, Ouganda",
  "contact.phoneValue": "+256 773515447",
  "contact.emailValue": "bientomart@gmail.com",
  "contact.hours": "Lun - Ven : 8h00 - 18h00 EAT",
  "contact.optWebsite": "Création de Site Web",
  "contact.optSMM": "Marketing sur les Réseaux Sociaux",
  "contact.optTraffic": "Forfaits Traffic",
  "contact.optAI": "Consultation Outils IA",
  "contact.optOther": "Autre",

  "footer.tagline": "Renforcer les entreprises ougandaises grâce à l'innovation digitale et aux solutions IA.",
  "footer.services": "Services",
  "footer.resources": "Ressources",
  "footer.newsletter": "Restez Informé",
  "footer.newsletterDesc": "Recevez des conseils de marketing digital et des mises à jour sur les outils IA dans votre boîte mail.",
  "footer.emailPlaceholder": "Votre adresse email",
  "footer.subscribe": "S'abonner",
  "footer.copyright": "© 2026 BientoMart. Tous droits réservés.",
  "footer.privacy": "Politique de Confidentialité",
  "footer.terms": "Conditions d'Utilisation",
  "footer.blog": "Blog",
  "footer.caseStudies": "Études de Cas",
  "footer.tutorials": "Tutoriels",
  "footer.faq": "FAQ",
  "footer.websiteCreation": "Création de Site Web",
  "footer.smm": "Marketing sur les Réseaux Sociaux",
  "footer.traffic": "Forfaits Traffic",
  "footer.aiReviews": "Avis sur les Outils IA",

  "svc.hiresTitle": "Engagez-Nous Pour Ce Service",
  "svc.hiresSubtitle": "Prêt à commencer ? Contactez-nous aujourd'hui pour une consultation gratuite.",
  "svc.getQuote": "Obtenir un Devis Gratuit",
  "svc.whatsapp": "Chattez sur WhatsApp",
  "svc.portfolioLabel": "Nos Réalisations",
  "svc.testimonialsLabel": "Témoignages Clients",
  "svc.processLabel": "Notre Processus",
  "svc.pricingLabel": "Plans Tarifaires",
  "svc.basic": "Basique",
  "svc.standard": "Standard",
  "svc.premium": "Premium",
  "svc.popular": "Le Plus Populaire",
  "svc.perMonth": "/ mois",
  "svc.oneTime": "paiement unique",
  "svc.chooseplan": "Choisir ce Plan",

  "review.overview": "Aperçu Rapide",
  "review.features": "Fonctionnalités Clés",
  "review.guide": "Guide Étape par Étape",
  "review.pricing": "Tarification",
  "review.verdict": "Verdict Final",
  "review.pros": "Avantages",
  "review.cons": "Inconvénients",
  "review.tryAffiliate": "Essayer Gratuitement",
  "review.getStarted": "Commencer avec",
  "review.bestFor": "Idéal Pour",
  "review.ourRating": "Notre Note",
  "review.freeTrialAvail": "Essai Gratuit Disponible",
  "review.yes": "Oui",

  "profile.title": "À Propos de BientoMart",
  "profile.subtitle": "Votre partenaire numérique de confiance en Ouganda",
  "profile.aboutTitle": "Autonomiser les entreprises grâce à l'innovation numérique",
  "profile.aboutP1": "BientoMart est la principale plateforme de services numériques en Ouganda, aidant les entreprises et entrepreneurs à construire une présence en ligne puissant depuis 2020.",
  "profile.aboutP2": "Notre équipe de designers, marketeux et spécialistes IA travaille sans relâche pour offrir des résultats exceptionnels aux clients à travers l'Afrique de l'Est.",
  "profile.aboutP3": "Nous combinons la technologie de pointe avec une connaissance approfondie du marché local pour créer des stratégies numériques qui résonnent vraiment avec les audiences ougandaises.",
  "profile.cta": "Contactez-Nous",
  "profile.valuesTitle": "Nos Valeurs Fondamentales",
  "profile.valuesSubtitle": "Les principes qui guident tout ce que nous faisons",
  "profile.teamTitle": "Rencontrez Notre Équipe",
  "profile.teamSubtitle": "Les personnes passionnées derrière BientoMart",
  "profile.whyTitle": "Pourquoi Choisir BientoMart",
  "profile.whySubtitle": "Ce qui nous distingue des autres",
  "profile.why1Title": "Livraison Rapide",
  "profile.why1Desc": "Nous livrons les projets dans les délais, à chaque fois. Pas de retards, pas d'excuses.",
  "profile.why2Title": "Tarification Abordable",
  "profile.why2Desc": "Des tarifs compétitifs adaptés aux entreprises et budgets ougandais.",
  "profile.why3Title": "Support 24/7",
  "profile.why3Desc": "Support permanent pour assurer que votre entreprise ne s'arrête jamais.",
  "profile.ctaTitle": "Prêt à Transformer Votre Entreprise?",
  "profile.ctaSubtitle": "Créons quelque chose d'incroyable ensemble. Contactez-nous aujourd'hui pour discuter de votre projet",
  "profile.ctaButton": "Commencer",
  "profile.callUs": "Appelez-Nous",

  "portfolio.title": "Notre Portfolio",
  "portfolio.subtitle": "Explorez nos projets réussis et voyez comment nous avons aidé les entreprises à atteindre leurs objectifs numériques",
  "portfolio.projectsCompleted": "Projets Terminés",
  "portfolio.happyClients": "Clients Satisfaits",
  "portfolio.yearsExperience": "Années d'Expérience",
  "portfolio.clientSatisfaction": "Satisfaction Client",
  "portfolio.visitProject": "Visiter le Projet",
  "portfolio.industriesTitle": "Industries Que Nous Servons",
  "portfolio.industriesSubtitle": "Notre expertise couvre plusieurs industries, offrant des solutions sur mesure pour chaque secteur",
  "portfolio.ctaTitle": "Prêt à Commencer Votre Projet?",
  "portfolio.ctaSubtitle": "Créons quelque chose d'incroyable ensemble. Contactez-nous aujourd'hui pour discuter de votre projet",
  "portfolio.startProject": "Commencer Votre Projet",
  "portfolio.viewServices": "Voir Nos Services",

  "nav.portfolio": "Portfolio",
};

export default fr;
